import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0d8f17a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header p-d-flex p-justify-between publish-main" }
const _hoisted_2 = { class: "campaign-name-header" }
const _hoisted_3 = {
  key: 0,
  class: "p-mb-4 p-d-flex bublish-block p-flex-wrap"
}
const _hoisted_4 = {
  key: 0,
  class: "preview-campaign"
}
const _hoisted_5 = {
  key: 2,
  class: "more_button p-ml-4 p-mr-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "texts" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "texts" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "texts" }, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  key: 0,
  class: "spinner-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampaignBrandHeader = _resolveComponent("CampaignBrandHeader")!
  const _component_PageSearchBar = _resolveComponent("PageSearchBar")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-page background", _ctx.padded && 'padded'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title || _ctx.config?.title) + " " + _toDisplayString(_ctx.type === 'draft' ? '(Draft)' : ''), 1),
      (_ctx.publishWithMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.type === 'draft')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Preview campaign"))
              : _createCommentVNode("", true),
            (_ctx.type === 'draft')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "publish_button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('publishCampaign')))
                }, "publish campaign"))
              : _createCommentVNode("", true),
            (_ctx.type === 'draft')
              ? (_openBlock(), _createElementBlock("button", _hoisted_5, _hoisted_9))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.brand)
          ? (_openBlock(), _createBlock(_component_CampaignBrandHeader, {
              key: 0,
              class: "header-brand",
              brand: _ctx.brand
            }, null, 8, ["brand"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.config?.search?.enabled)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createVNode(_component_PageSearchBar, {
            defaultSearchType: _ctx.config?.search.defaultType,
            placeholder: _ctx.config?.search.placeholder,
            onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search', $event))),
            onClearSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clearSearch')))
          }, null, 8, ["defaultSearchType", "placeholder"])
        ], true)
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_ProgressSpinner, { class: "spinner" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { loading: _ctx.loading }, undefined, true)
        ]),
        _: 3
      }),
      _renderSlot(_ctx.$slots, "router", {}, undefined, true)
    ])
  ], 2))
}